/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { indexNowRunStatuses } from '@repo/config';
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const getIndexnowStatusV1ResultSchema = z.object({
  status: z.enum(indexNowRunStatuses),
  phase: z.string().nullish(),
  sitemaps: z.number().nullish(),
  urls: z.number().nullish(),
  batches: z.number().nullish(),
  ok: z.number().nullish(),
  error: z.string().nullish(),
  startedAt: z.number().nullish(),
  finishedAt: z.number().nullish(),
});

export type IGetIndexnowStatusV1Result = z.infer<typeof getIndexnowStatusV1ResultSchema>;

export const getIndexnowStatusV1ResponseSchema = createApiResponseSchema(
  getIndexnowStatusV1ResultSchema,
) as z.ZodSchema<IAPI<IGetIndexnowStatusV1Result>>;

export type IGetIndexnowStatusV1Response = IAPI<IGetIndexnowStatusV1Result>;
